<template>
  <div class="content-wrap">
    <h2>Feedback?</h2>
    <p class="light">Werkt er iets in de app niet naar behoren? Via de onderstaande knop kun je contact opnemen met het
      technische team.</p>

    <p class="light">Check je eerst even de <a target="_blank" href="https://www.broodjedunner.nl/pages/veelgestelde-vragen">Veelgestelde
      vragen?</a></p>

    <a href="mailto:broodjedunner@websheriff.nl" class="btn wide">
      Neem contact op
    </a>
  </div>
</template>

<script>
export default {
  name: "Feedback",
};
</script>
